<template>
<div>
  <div class="my-4">
    <v-row>
      <v-col cols="4">
        <strong>クラス選択</strong>
        <class-picker
          :classes="classes"
          @update:modelValue="selectClassName"
        ></class-picker>
      </v-col>
      <v-col cols="4">
        <v-checkbox
          v-model="showQuit"
          color="primary"
          label="退園済み"
        ></v-checkbox>
      </v-col>
    </v-row>
  </div>

  <v-progress-linear v-if="isFetching" indeterminate color="primary" class="my-4" />

  <v-data-table
    class="pt-4"
    :items="childrenWithDevices"
    :headers="childrenTableHeaders"
    hide-default-footer
    :items-per-page="-1"
    item-key="childId"
  >
    <template v-slot:[`item.name`]="{ item }">
      {{ `${item.child.lastName} ${item.child.firstName}` }}
    </template>

    <template v-slot:[`item.class`]="{ item }">
      {{ getClassName(item.child) }}
    </template>

    <template v-slot:[`item.sensors`]="{ item }">
      <v-chip
        close
        v-for="device in item.devices"
        :key="device.sid"
        @click:close="remove(item.child.childId, device.sid)"
      >
        {{ device.sid }}
      </v-chip>
    </template>


    <template v-slot:[`item.edit`]="{ item }">
      <v-btn
        color="primary"
        variant="flat"
        :id="item.child.childId"
        @click="() => selectedChild = item.child"
      >
        追加
      </v-btn>
    </template>
  </v-data-table>

  <v-dialog
    :value="selectedChild !== null"
    @click:outside="() => selectedChild = null"
    max-width="720"
  >
    <v-card class="pa-4" v-if="selectedChild">
      <div class="mb-4">
        <h4>{{ selectedChild.lastName }}  {{ selectedChild.firstName }}</h4>
      </div>
      <p class="text-caption">{{ $t('common_actions.readerInstruction') }}</p>
      <v-row align="center">
        <v-col cols="3">
          センサーID
        </v-col>
        <v-col cols="6">
          <div
            class="device-result"
          >
            {{ detectedIdm }}
          </div>
        </v-col>
        <v-col cols="3">
          <v-btn
            color="primary"
            variant="flat"
            rounded
            @click="read"
          >
            読み取り
          </v-btn>
        </v-col>
      </v-row>
      <v-progress-linear v-if="isRegistering" indeterminate color="primary" class="my-4" />
      <div class="mt-8">
        <v-btn
          color="primary"
          variant="flat"
          block
          large
          :disabled="!detectedIdm || isRegistering"
          @click="register"
        >
          登録
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</div>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue';
import { classModule } from '@/store/dataModules/classModule';
import { pasoriVevoModule } from '@/store/viewModules/pasori/pasoriVevoModule'
import ClassPicker from '@/components/atoms/ClassPicker.vue';
import { NurseryChildResponse, NurseryClassResponse } from 'chaild-api/lib';
import { PasoriDevice } from '@/api/ApiDevice';
import {
  NFCPortLib,
  Configuration,
  DetectionOption,
  array_tohexs
} from '@/lib/NFCPortLib'


interface DataType {
  isFetching: boolean;
  showQuit: boolean;
  classId: number | null;
  selectedChild: NurseryChildResponse | null;
  detectedIdm: string | null;
  isRegistering: boolean;
}

interface ChildWithDevices {
  child: NurseryChildResponse;
  devices: PasoriDevice[];
}

export default defineComponent({
  components: {
    ClassPicker
  },

  data: (): DataType => {
    return {
      isFetching: false,
      showQuit: false,
      classId: null,
      selectedChild: null,
      detectedIdm: null,
      isRegistering: false,
    }
  },

  computed: {
    classes(): NurseryClassResponse[] {
      return classModule.classes
    },
    childrenTableHeaders: function() {
      return [
        { text: '園児氏名', value: 'name', },
        { text: 'クラス名', value: 'class', },
        { text: 'IDM', value: 'sensors', },
        { text: '', value: 'edit', },
      ];
    },
    children() {
      if (!this.showQuit) {
        return pasoriVevoModule.children.filter((c) => c.quitDate === null)
      }
      return pasoriVevoModule.children
    },
    keyholders() {
      return pasoriVevoModule.keyholders
    },
    childrenWithDevices(): ChildWithDevices[] {
      return this.children.map((c) => {
        const devices = pasoriVevoModule.keyholders.filter((device) => device.childId === c.childId)
        return {
          child: c,
          devices: devices
        }
      })
    }
  },

  methods: {
    getClassName(child: NurseryChildResponse) {
      if (child.nurseryClasses) {
        const latest = child.nurseryClasses.length > 0 ? child.nurseryClasses[0] : null;
        if (latest) {
          return latest.className
        }
      }
      return '-';
    },
    async selectClassName(classId: number) {
      this.isFetching = true;
      this.classId = classId;
      await Promise.all([
        pasoriVevoModule.listChildren({ classId }),
        pasoriVevoModule.listKeyholders({ classId })
      ])
      this.isFetching = false;
    },
    async read() {
      const lib = new NFCPortLib()
      const nfcConfig = new Configuration(500, 500, true, true);

      try {
        await lib.init(nfcConfig);
        await lib.open();
      } catch {
        alert(this.$t('ui.deviceConnectionFailed'))
      }

      /* detectCard(FeliCa Card) */
      const detectOption = new DetectionOption(new Uint8Array([0xff, 0xff]), 0, true, false, null);
      const card = await lib.detectCard('iso18092', detectOption)
        .then(ret => {
          return ret;
        }, (error) => {
          // detectTitle.innerText = 'Card is not detected';
          console.log(error)
          // throw (error);
        });

      this.detectedIdm = array_tohexs(card.idm)

      /* close() */
      await lib.close();
    },
    async register() {
      if (
        this.selectedChild
        && this.detectedIdm
        && this.classId
      ) {
      this.isRegistering = true;

      await pasoriVevoModule.registerKeyholder({
        sid: this.detectedIdm,
        childId: this.selectedChild.childId,
        classId: this.classId
      })
      
      this.selectedChild = null;
      this.detectedIdm = null;
      this.isRegistering = false;
      }
    },
    async remove(childId: number, sid: string) {
      if (
        this.classId
      ) {
        this.isFetching = true;
        await pasoriVevoModule.removeKeyholder({
          childId,
          sid,
          classId: this.classId
        })
        this.isFetching = false
      }
    }
  },
  // async mounted() {

  // }
})
</script>
<style lang="scss" scoped>
.device-result {
  border: solid 1px #e0e0e0;
  border-radius: 4px;
  padding: 8px;

  height: 40px;
}

</style>